module.exports = __webpack_public_path__ + "static/media/fly0012.16c18c55.webp";